import {getCSSVariableValue} from 'assets/ts/_utils'
import {FC, useEffect} from 'react'
import topbar from 'topbar'

const pColor = getCSSVariableValue('--kt-primary')
const sColor = getCSSVariableValue('--kt-success')

interface ITop {
  hide: () => void
  show: () => void
}

const config = {
  barColors: {
    '0': pColor,
    '1': sColor,
  },
  barThickness: 2,
  shadowBlur: 5,
}

topbar.config(config)
const topProgress: ITop = topbar

const TopProgressCom: FC = () => {
  useEffect(() => {
    topProgress.show()
    return () => topProgress.hide()
  }, [])

  return <></>
}

export {TopProgressCom, topProgress}
